import { useState } from 'react';
import './LoginForm.css';

function LoginForm({ onLoginSuccess }) {
  const [mode, setMode] = useState('login');

  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [email, setEmail] = useState('');
  const [registerLogin, setRegisterLogin] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');

  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetMessages = () => {
    setError('');
    setMessage('');
  };

  const switchMode = (newMode) => {
    resetMessages();
    setMode(newMode);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    resetMessages();
    setIsSubmitting(true);

    try {
      const response = await fetch('/go/php/auth/login.php', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          login: login.trim(),
          password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Connexion impossible');
      }

      await onLoginSuccess(data.user);
      setLogin('');
      setPassword('');
    } catch (err) {
      setError(err.message || 'Connexion impossible');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    resetMessages();
    setIsSubmitting(true);

    try {
      const response = await fetch('/go/php/auth/register.php', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nom: nom.trim(),
          prenom: prenom.trim(),
          email: email.trim(),
          login: registerLogin.trim(),
          password: registerPassword,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Inscription impossible');
      }

      setMessage(
        data.message ||
          'Compte créé. Vous devez maintenant valider votre adresse email.'
      );

      setNom('');
      setPrenom('');
      setEmail('');
      setRegisterLogin('');
      setRegisterPassword('');
    } catch (err) {
      setError(err.message || 'Inscription impossible');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="version">LFAT v 4.1.1</div>

        {error && <div className="login-error">{error}</div>}
        {message && <div className="login-success">{message}</div>}

        {mode === 'login' ? (
          <>
            <input
              type="text"
              placeholder="Login ou email"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
            />

            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button onClick={handleLogin} disabled={isSubmitting}>
              {isSubmitting ? 'Connexion...' : 'Se connecter'}
            </button>

            <button
              type="button"
              className="login-secondary-button"
              onClick={() => switchMode('register')}
              disabled={isSubmitting}
            >
              Créer un compte
            </button>
          </>
        ) : (
          <>
            <input
              type="text"
              placeholder="Nom"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
            />

            <input
              type="text"
              placeholder="Prénom"
              value={prenom}
              onChange={(e) => setPrenom(e.target.value)}
            />

            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="text"
              placeholder="Login"
              value={registerLogin}
              onChange={(e) => setRegisterLogin(e.target.value)}
            />

            <input
              type="password"
              placeholder="Mot de passe (8 caractères minimum)"
              value={registerPassword}
              onChange={(e) => setRegisterPassword(e.target.value)}
            />

            <button onClick={handleRegister} disabled={isSubmitting}>
              {isSubmitting ? 'Création...' : 'Créer mon compte'}
            </button>

            <button
              type="button"
              className="login-secondary-button"
              onClick={() => switchMode('login')}
              disabled={isSubmitting}
            >
              Retour à la connexion
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default LoginForm;
